import React from "react";

/** Moved from oem's `~/icons/icons`; oem re-exports it from there. */
export const DownAngleSmallIcon = ({ strokeColor, ...props }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13 6L8 11L3 6"
      stroke={strokeColor || "#172B4D"}
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DownAngleSmallIcon;
